<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <div class="map-wrapper" @mouseover="removeHoverItem">
    <vue-daum-map
      :appKey="appKey"
      :center.sync="center"
      :level.sync="level"
      :mapTypeId="mapTypeId"
      :libraries="libraries"
      :style="{width:'100%', height: '100%'}"
      v-if="center.lat && center.lng"
      @load="loadMaps"
      @idle="updateKosiwon"
      @bounds_changed="updatePolyline"
      @zoom_change="clearMapObject"
      @mousemove="removeHoverItem"
      @click="() => {
        this.$store.dispatch('setSearchKosiwonList', kosiwonList)
        this.removeClickStyle(this.clickedItem)
        this.collagesOverlay.removeRangeObject()
        this.subwayOverlay.removeRangeObject()
        this.$store.dispatch('setOpenStatus', '')
      }"
     >
    </vue-daum-map>
    <locate-button />
  </div>
</template>

<script>
  import VueDaumMap from 'vue-daum-map'
  import CityAndStateOverlay from './CityAndStateOverlay.js'
  import CollagesAndSubwayOverlay from './CollagesAndSubwayOverlay'
  import cities from '../../const/cities'
  import states from '../../const/states'
  import collages from '../../const/collages'
  import subway from '../../const/subwayStations'
  import packageMarkerImage from '../../assets/images/ex-p.png'
  import defaultMarkerImage from '../../assets/images/ex-n.png'
  import packageMarkerOnImage from '../../assets/images/ex-p-on.png'
  import defaultMarkerOnImage from '../../assets/images/ex-n-on.png'
  import hoverKosiwonMarker from '../../assets/images/ex-on.png'
  import {mapState} from 'vuex'
  import MapConstant from '../../const/maps'
  import EventBus from '../../core/modules/eventBus'
  import LocateButton from './LocateButton'

  export default {
    name: 'SearchMap',
    props: {
      kosiwonList: {
        type: Array,
        default: () => []
      }
    },
    components: {LocateButton, VueDaumMap},
    data: () => ({
      appKey: MapConstant.APP_KEY, // 테스트용 appkey
      center: {
        lat: undefined,
        lng: undefined
      }, // 지도의 중심 좌표
      level: 3, // 지도의 레벨(확대, 축소 정도),
      mapTypeId: MapConstant.MAP_TYPE, // 맵 타입
      libraries: MapConstant.LIBRARIES, // 추가로 불러올 라이브러리
      map: null, // 지도 객체. 지도가 로드되면 할당됨.
      clusterManager: null,
      polyline: null,
      markers: [],
      latlngBound: null,
      initMapDoLevel :9,
      initMapCityLevel :9,
      initMapSearchLevel : 6,
      cityOverlay: null,
      stateOverlay: null,
      collagesOverlay: null,
      subwayOverlay: null,
      clickedItem: null,
      hoverItem: null,
      hoverKosiwonMarker: null
    }),
    computed: {
      ...mapState({
        hoverKosiwon: state => state.SEARCH.HOVER_KOSIWON,
        centerState: state => state.MAPS.CENTER
      })
    },
    watch: {
      // 검색이나 기타 화면 이동등으로 고시원 리스트 조회 시 Watch 에서 감지하여 고시원을 그린다.
      kosiwonList (newVal) {
        if (this.map && this.clusterManager) {
          this.drawKosiwons(newVal)
        }
      },
      hoverKosiwon () {
        this.setHoverKosiwonLocation()
      },
      // 센터 변경 시 (지도 이동) 이벤트 발생
      centerState (newVal) {
        this.center = {
          lat: newVal.LATITUDE,
          lng: newVal.LONGITUDE
        }

        this.map.setCenter(new this.daum.maps.LatLng(this.center.lat, this.center.lng))
      }
    },
    methods: {
      async loadMaps (context) {
        this.map = context
        this.setClusterManager()
        this.createPolyline()
        this.setClusterClickEvent ()
        this.setClusterHoverEvent()
        this.cityOverlay = new CityAndStateOverlay(
          cities,
          this.daum,
          context,
          this.initMapSearchLevel - 1
        )
        this.stateOverlay = new CityAndStateOverlay(
          states,
          this.daum,
          context,
          this.initMapCityLevel - 1
        )

        this.collagesOverlay = new CollagesAndSubwayOverlay(
          'collages',
          collages,
          this.daum,
          context,
          this.$store,
          this.axios
        )
        this.subwayOverlay = new CollagesAndSubwayOverlay(
          'subway',
          subway,
          this.daum,
          context,
          this.$store,
          this.axios
        )

        this.updateKosiwon()
      },

      // CLUSTER
      setClusterManager () {
        this.clusterManager = new this.daum.maps.MarkerClusterer({
          map: this.map, // 마커들을 클러스터로 관리하고 표시할 지도 객체
          averageCenter: true, // 클러스터에 포함된 마커들의 평균 위치를 클러스터 마커 위치로 설정
          minLevel: 3, // 클러스터 할 최소 지도 레벨
          disableClickZoom: true, // 클러스터 마커를 클릭했을 때 지도가 확대되지 않도록 설정한다 ,

          calculator: [2], // 클러스터의 크기 구분 값, 각 사이값마다 설정된 text나 style이 적용된다
          //texts: getTexts, // texts는 ['삐약', '꼬꼬', '꼬끼오', '치멘'] 이렇게 배열로도 설정할 수 있다
          styles: [
            { // calculator 각 사이 값 마다 적용될 스타일을 지정한다
              width: this.$mq === 'sm' ? '6rem' : '4rem', height: this.$mq === 'sm' ? '6rem' : '4rem',
              background: '#3c6bbb',
              borderRadius: this.$mq === 'sm' ? '6rem' : '4rem',
              borderStyle: 'solid',
              // borderColor: '',
              // borderWidth: '2px',
              color: '#fff',
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: this.$mq === 'sm' ? '2rem' : '1.5rem',
              lineHeight: this.$mq === 'sm' ? '6rem' : '4rem'
            }
          ]
        })
      },
      setClusterClickEvent () {
        this.daum.maps.event.addListener(this.clusterManager, 'clusterclick', (cluster) => {
          const markerList = cluster.getMarkers()
          const kosiwonList = []
          markerList.map(marker => {
            kosiwonList.push(marker.kosiwon)
          })
          this.collagesOverlay.removeRangeObject()
          this.subwayOverlay.removeRangeObject()
          this.setClickStyle(cluster)
          this.$store.dispatch('setSearchKosiwonList', kosiwonList)
          if (this.$mq === 'sm') {
            this.$store.dispatch('setOpenStatus', 'small')
          }
        })
      },
      setClusterHoverEvent () {
        // this.daum.maps.event.addListener(this.clusterManager, 'clusterover', this.hoverClusterStyle)
        // this.daum.maps.event.addListener(this.clusterManager, 'clusterout', this.outClusterStyle)
      },
      clearCluster () {
        if (!this.clusterManager) return

        this.clusterManager.removeMarkers(this.markers)
        // this.map.relayout()
      },
      getClusterDom (cluster) {
        return cluster._content
      },
      isCluster (cluster) {
        return cluster && cluster.hasOwnProperty('_clusterer')
      },

      // MARKER
      getMarkerImage (packageType, isClicked) {
        let imageSrc
        let imageSize
        if (packageType === 'N' || packageType === 'B') {
          imageSrc = isClicked ? defaultMarkerOnImage : defaultMarkerImage // 마커이미지의 주소입니다
          imageSize = new this.daum.maps.Size(20, 30)
        } else {
          imageSrc = isClicked ? packageMarkerOnImage : packageMarkerImage // 마커이미지의 주소입니다
          imageSize = new this.daum.maps.Size(35, 47) // 마커이미지의 크기입니다
        }

        const imageOption = {offset: new this.daum.maps.Point(0, 35)} // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.
        return new this.daum.maps.MarkerImage(imageSrc, imageSize, imageOption)
      },
      createMarker (kosiwon) {

        const markerImageObj = this.getMarkerImage(kosiwon.package_type)
        const location = kosiwon.location.coordinates
        const position = new this.daum.maps.LatLng(location[0], location[1])
        const marker = new this.daum.maps.Marker({
          map: this.map,
          position: position,
          clickable: true,
          image: markerImageObj
        })

        marker.kosiwon = kosiwon

        this.daum.maps.event.addListener(marker, 'click', () => {
          this.setMarkerClickEvent(marker)
        })
        this.daum.maps.event.addListener(marker, 'mouseover', () => {
          // this.setMarkerHoverEvent(marker)
        })
        this.daum.maps.event.addListener(marker, 'mouseout', () => {
          // this.setMarkerOutEvent(marker)
        })

        this.markers.push(marker)
      },
      setMarkerClickEvent (marker) {
        this.collagesOverlay.removeRangeObject()
        this.subwayOverlay.removeRangeObject()
        this.setClickStyle(marker)
        this.$store.dispatch('setSearchKosiwonList', [marker.kosiwon])
        if (this.$mq === 'sm') {
          this.$store.dispatch('setOpenStatus', 'small')
        }
      },

      // Event
      setClickStyle (target) {
        if (this.clickedItem) {
          this.removeClickStyle(this.clickedItem)
        }

        this.clickedItem = target

        if (this.isCluster(this.clickedItem)) {
          const clusterDom = this.getClusterDom(this.clickedItem)
          clusterDom.classList.add('cluster-on')
        } else {
          const markerImage = this.getMarkerImage(target.kosiwon.package_type, true)
          target.setImage(markerImage)
        }
      },
      removeClickStyle (target) {
        if (!target) {
          return
        }

        if (this.isCluster(target)) {
          const clusterDom = this.getClusterDom(this.clickedItem)

          if(  clusterDom !=null  ) clusterDom.classList.remove('cluster-on')
        } else {
          const markerImage = this.getMarkerImage(target.kosiwon.package_type, false)
          target.setImage(markerImage)
        }
      },
      clearMapObject() {
        this.clearCluster(true)
        this.cityOverlay.removeMap()
        this.stateOverlay.removeMap()
        this.collagesOverlay.removeRangeObject()
        this.subwayOverlay.removeRangeObject()
      },
      removeHoverItem () {
        const kosiwon = this.$store.getters.getHoverKosiwon
        if (kosiwon) {
          this.$store.dispatch('setHoverKosiwon', undefined)
        }
      },

      // MAP DIMENSION
      getBounds () {
        // 지도의 현재 영역을 얻어옵니다
        const bounds = this.map.getBounds()

        // 영역의 남서쪽 좌표를 얻어옵니다
        const swLatLng = bounds.getSouthWest()

        // 영역의 북동쪽 좌표를 얻어옵니다
        const neLatLng = bounds.getNorthEast()

        return {
          swLatLng,
          neLatLng
        }
      },
      createPolyline () {
        // 지도의 현재 영역을 얻어옵니다

        const {swLatLng, neLatLng} = this.getBounds()

        if (!this.polyline) {
          this.polyline = new this.daum.maps.Polyline({
            path: [
              swLatLng,
              neLatLng
            ]
          })
        }

        this.saveMapDistance()
      },
      updatePolyline () {
        const {swLatLng, neLatLng} = this.getBounds()

        this.polyline.setPath([
          swLatLng,
          neLatLng
        ])

        this.saveMapDistance()
      },
      saveMapDistance() {
        const radius = Math.round(this.polyline.getLength() / 2)
        if (radius !== this.$store.getters.getBoundsDistance) {
          this.$store.dispatch('setBoundsDistance', Math.round(this.polyline.getLength() / 2))
        }
      },
      changeCenter () {
        const bounds = this.map.getBounds()
        const sw = bounds.getSouthWest()
        const ne = bounds.getNorthEast()
        this.$store.dispatch('setMapBounds', {
          sw: {
            lat: sw.getLat(),
            lng: sw.getLng()
          },
          ne: {
            lat: ne.getLat(),
            lng: ne.getLng()
          }
        })

        this.$store.dispatch('setMapCenter', {
          latitude: this.center.lat,
          longitude: this.center.lng
        })
      },

      // KOSIWONS
      drawKosiwons () {
        if (this.level < this.initMapSearchLevel) {
          this.clusterManager.removeMarkers(this.markers)
          this.markers = []
          console.time('kosiwonList')
          this.kosiwonList.map(kosiwon => {
            this.createMarker(kosiwon)
          })
          this.clusterManager.addMarkers(this.markers)
          console.timeEnd('kosiwonList')
        }
      },
      updateKosiwon () {
        setTimeout(() => {
          this.collagesOverlay.removeRangeObject()
          this.subwayOverlay.removeRangeObject()

          if (this.level >= this.initMapCityLevel) {
            this.clearCluster(true)
            this.cityOverlay.removeMap()
            this.stateOverlay.setMap()
            this.collagesOverlay.removeMap()
            this.subwayOverlay.removeMap()
          } else if (this.level <= this.initMapCityLevel && this.level >= this.initMapSearchLevel) {
            this.clearCluster(true)
            this.cityOverlay.setMap()
            this.stateOverlay.removeMap()
            this.collagesOverlay.removeMap()
            this.subwayOverlay.removeMap()
          } else {
            this.stateOverlay.removeMap()
            this.cityOverlay.removeMap()
            this.collagesOverlay.setMap()
            this.subwayOverlay.setMap()
          }
          this.changeCenter()
          this.$store.dispatch('setOpenStatus', '')
        })
      },
      setHoverKosiwonLocation() {
        const kosiwon = this.$store.getters.getHoverKosiwon

        if (this.hoverKosiwonMarker) {
          this.hoverKosiwonMarker.setMap(null)
          this.hoverKosiwonMarker = null
        }

        if (!kosiwon) {
          return
        }

        let imageSrc = hoverKosiwonMarker
        const imageSize = new this.daum.maps.Size(20, 30)

        const imageOption = {offset: new this.daum.maps.Point(0, 35)} // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.
        const markerImageObj = new this.daum.maps.MarkerImage(imageSrc, imageSize, imageOption)

        const location = kosiwon.location.coordinates
        const position = new this.daum.maps.LatLng(location[0], location[1])
        this.hoverKosiwonMarker = new this.daum.maps.Marker({
          map: this.map,
          position: position,
          clickable: true,
          image: markerImageObj
        })
      },

    },
    mounted () {
      const center = this.$store.getters.getMapCenter

      this.center.lat = center.latitude
      this.center.lng = center.longitude

      // 이벤트 구독
      EventBus.$on('toggleListView', () => {
        setTimeout(() => {
          this.map.relayout()
        }, 100)
      })

      EventBus.$on('clearClickedMapObject', () => {
        this.removeClickStyle(this.clickedItem)
      })

      if (this.$mq === 'sm') {
        this.level = 5
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";

  .map-wrapper {
    width:100%;
    height: 100%;
    background: #cccccc;
    position: relative;
  }
</style>

<style lang="less">
  @import "../../assets/css/palette";

  #vue-naver-maps {
    height: 100%;
  }
  .cluster-on {
    box-sizing: border-box;
    background: white !important;
    border: 3px solid @windows-blue !important;
    color: @windows-blue !important;
    line-height: 3.6rem !important;
  }
</style>

<style lang="less" >
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    .cluster-on {
      line-height: 5.4rem !important;
    }
  }
</style>

